import { useContext } from 'react';
import { ToastContext } from '../contexts/SnackbarContext';

export const useSnackbarContext = () => useContext(ToastContext);
